const styles = () => ({
  sortButton: {
    background: 'transparent',
    border: 'none',
    height: '100%',
    marginRight: '3px',
    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  buttonText: {
    whiteSpace: 'nowrap',
    color: '#36425A',
    fontSize: '14px',
    fontWeight: 300,
    paddingRight: '5px',
  },
});

export default styles;
